import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { featuredComics, latestComics } from '@/mocks/comics';

const allComics = [...featuredComics, ...latestComics];

const chaptersList = [
  { num: 1, title: '故事的开始', date: '2025-01-15' },
  { num: 2, title: '意外的相遇', date: '2025-01-22' },
  { num: 3, title: '命运的交织', date: '2025-01-29' },
  { num: 4, title: '隐藏的秘密', date: '2025-02-05' },
  { num: 5, title: '内心的挣扎', date: '2025-02-12' },
  { num: 6, title: '勇敢的决定', date: '2025-02-19' },
  { num: 7, title: '新的开始', date: '2025-02-26' },
  { num: 8, title: '考验来临', date: '2025-03-05' },
  { num: 9, title: '真相浮现', date: '2025-03-12' },
  { num: 10, title: '心的方向', date: '2025-03-19' },
  { num: 11, title: '重逢之时', date: '2025-03-26' },
  { num: 12, title: '彼方的约定', date: '2025-04-02' },
];

export default function ComicPage() {
  const { slug } = useParams<{ slug: string }>();
  const comic = allComics.find((c) => c.slug === slug) || featuredComics[0];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const relatedComics = allComics.filter((c) => c.slug !== slug).slice(0, 4);

  const comicTitle = comic.title;
  const comicDescription = 'description' in comic ? comic.description : '暂无简介';
  const comicAuthor = 'author' in comic ? comic.author : '未知作者';
  const comicTags = 'tags' in comic ? comic.tags : [];
  const comicStatus = 'status' in comic ? comic.status : '连载中';
  const comicAltTitle = 'altTitle' in comic ? comic.altTitle : '';
  const comicViews = 'views' in comic ? comic.views : 'N/A';
  const comicCategory = comic.category;
  const categoryNameMap: Record<string, string> = {
    romance: '恋爱浪漫', action: '热血动作', fantasy: '奇幻冒险', drama: '都市剧情',
    comedy: '搞笑日常', thriller: '悬疑惊悚', historical: '古风历史', 'slice-of-life': '治愈日常',
  };
  const categoryName = categoryNameMap[comicCategory] || '漫画分类';
  const canonicalUrl = `http://kcptesw.com/comic/${slug || ''}`;

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <Link to={`/category/${comicCategory}`} className="hover:text-primary-600 transition-colors">
              {categoryName}
            </Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800 font-medium">{comicTitle}</span>
          </nav>

          <article className="flex flex-col lg:flex-row gap-8">
            <div className="lg:w-[300px] flex-shrink-0">
              <div className="aspect-[3/4] rounded-xl overflow-hidden sticky top-24">
                <img src={comic.cover} alt={comicTitle} title={`${comicTitle} 韩漫画 免费在线观看`} className="w-full h-full object-cover object-top" />
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2 mb-3">
                <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
                  {comicCategory === 'romance' ? '恋爱' : comicCategory === 'action' ? '动作' : comicCategory === 'fantasy' ? '奇幻' : comicCategory === 'drama' ? '剧情' : comicCategory === 'comedy' ? '搞笑' : comicCategory === 'thriller' ? '悬疑' : comicCategory === 'historical' ? '古风' : '治愈'}
                </span>
                <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${comicStatus === '连载中' ? 'bg-accent-500 text-background-50' : 'bg-foreground-600 text-background-50'}`}>
                  {comicStatus}
                </span>
              </div>

              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">{comicTitle}</h1>
              {comicAltTitle && <p className="text-sm text-foreground-500 mb-4">{comicAltTitle}</p>}

              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-600 mb-6">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i>
                  <strong>{comicAuthor}</strong>
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500"></i>
                  {comic.rating} 分
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {comicViews} 阅读
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-file-list-3-line"></i>
                  {comic.chapters} 话
                </span>
              </div>

              {comicTags.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-5">
                  {comicTags.map((tag: string) => (
                    <span key={tag} className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs">#{tag}</span>
                  ))}
                </div>
              )}

              <p className="text-sm text-foreground-700 leading-relaxed mb-8 max-w-2xl">
                {comicDescription}
              </p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-8">
                <Link
                  to="#"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line"></i>
                  <span>开始阅读第1话</span>
                </Link>
                <Link
                  to="#"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-bookmark-line"></i>
                  <span>加入收藏</span>
                </Link>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-950 mb-4">章节列表 <span className="text-sm font-normal text-foreground-500">(共{chaptersList.length}话)</span></h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-[400px] overflow-y-auto pr-1">
                  {chaptersList.map((ch) => (
                    <Link
                      key={ch.num}
                      to="#"
                      className="flex items-center justify-between px-4 py-3 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
                    >
                      <span className="flex items-center gap-2 text-sm">
                        <span className="text-foreground-400 text-xs font-mono">第{ch.num}话</span>
                        <span className="text-foreground-800 font-medium group-hover:text-primary-600 transition-colors">{ch.title}</span>
                      </span>
                      <span className="text-xs text-foreground-400 hidden sm:inline">{ch.date}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </article>

          {relatedComics.length > 0 && (
            <section className="mt-14 pt-10 border-t border-background-200/70">
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-6">相关推荐</h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                {relatedComics.map((rc) => (
                  <Link
                    key={rc.id}
                    to={`/comic/${rc.slug}`}
                    className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                  >
                    <div className="aspect-[3/4] overflow-hidden">
                      <img src={rc.cover} alt={rc.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                    </div>
                    <div className="p-3">
                      <h3 className="font-heading text-sm font-bold text-foreground-950 line-clamp-1">{rc.title}</h3>
                      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                        <span className="flex items-center gap-1"><i className="ri-star-fill text-accent-500 text-[10px]"></i>{rc.rating}</span>
                        <span>{rc.chapters}话</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          )}
        </div>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Article',
        'headline': `${comicTitle} - 韩漫网免费在线观看`,
        'description': comicDescription,
        'author': { '@type': 'Person', 'name': comicAuthor },
        'datePublished': '2025-01-15',
        'dateModified': '2026-07-03',
        'image': comic.cover,
        'url': canonicalUrl,
        'publisher': { '@type': 'Organization', 'name': '韩漫网', 'url': 'http://kcptesw.com/' },
        'mainEntityOfPage': { '@type': 'WebPage', '@id': canonicalUrl },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'http://kcptesw.com/' },
            { '@type': 'ListItem', 'position': 2, 'name': categoryName, 'item': `http://kcptesw.com/category/${comicCategory}` },
            { '@type': 'ListItem', 'position': 3, 'name': comicTitle, 'item': canonicalUrl },
          ],
        },
      }) }} />
    </>
  );
}